var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Icon, CountryList } from "../../UI";
import { Translate } from "../../I18N";

const style = { display: 'inline-block', width: '25px' };

export default class IconSelectorItem extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.item._id !== nextProps.item._id;
  }

  render() {
    const { item } = this.props;

    let icon = /*#__PURE__*/_jsx(Translate, {}, void 0, "No icon / flag");
    if (item.type === 'Icons') {
      icon = /*#__PURE__*/
      _jsx("span", { style: style }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: `${item._id}` })
      );

    }

    if (item.type === 'Flags') {
      const className = `flag-icon flag-icon-${CountryList.get(item._id).cca2}`.toLowerCase();
      icon = /*#__PURE__*/
      _jsx("span", { style: style }, void 0, /*#__PURE__*/
      _jsx("span", { className: className })
      );

    }

    return /*#__PURE__*/(
      _jsx("span", {}, void 0,
      icon,
      item.label
      ));

  }
}

IconSelectorItem.defaultProps = {
  item: undefined
};